import axios, {AxiosResponse} from 'axios';
import {baseUrlAgentSystem} from '../api/api';
import {store} from '../redux/store';

export interface MetadataResponse {
  title: string;
  description: string;
  ogTitle?: string;
  ogDescription?: string;
  favicon: string;
}

const parseMetadata = async (href: string): Promise<MetadataResponse> => {
  try {
    const {metadata} = store.getState().chat;
    if (metadata && metadata[href]) {
      return metadata[href] as MetadataResponse;
    }
    // Use dedicated metadata endpoint if available
    const url = `${baseUrlAgentSystem}/api/metadata?url=${encodeURIComponent(href)}`;
    const response: AxiosResponse<MetadataResponse> = await axios.get(url);
    return response.data;
  } catch (error) {
    return {
      title: '',
      description: '',
      favicon: `https://www.google.com/s2/favicons?sz=32&domain=${href}`,
    } as MetadataResponse;
  }
};

export default parseMetadata; 